import { useSessionUser } from '@contexts/SessionUserContext';
import React from 'react';
import { Navigate } from 'react-router-dom';

import ContentContainer from '@components/ContentContainer';
import { useTeamUsersQuery } from '@queries/team-users';
import { useTeamsQuery } from '@queries/teams';

const RootPage: React.FC = () => {
  // Call all hooks first - before any conditional returns
  const { userId, isInitialQueryFinished } = useSessionUser();

  const teamUsersQuery = useTeamUsersQuery(
    {
      userIds: userId ? [userId] : [],
    },
    !!userId,
  );
  const teamIds = teamUsersQuery.data?.map((teamUser) => teamUser.teamId);

  const teamsQuery = useTeamsQuery(
    {
      teamIds: teamIds ?? [],
    },
    !!teamIds?.length,
  );
  const teams = teamsQuery.data ?? [];

  // Handle conditional renders after all hooks are called

  // If authentication check hasn't completed yet, show loading state
  if (!isInitialQueryFinished) {
    return <ContentContainer.Loading />;
  }

  // If user is not authenticated, redirect to login
  if (!userId) {
    return <Navigate to="/auth/login" replace={true} />;
  }

  // Show loading state for data fetching
  if (teamUsersQuery.isLoading || teamsQuery.isLoading) {
    return <ContentContainer.Loading />;
  }

  // Redirect to the first team
  if (teams.length > 0) {
    return <Navigate to={`/team/${teams[0]!.teamId}`} replace={true} />;
  }

  // If there are no teams, redirect to the team creation page
  return <Navigate to={`/team/create`} replace={true} />;
};

export default RootPage;
